import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

function PrivateRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Verificar autenticación con un pequeño delay para asegurar que localStorage esté listo
    const checkAuth = () => {
      const authenticated = authService.isAuthenticated();
      setIsAuthenticated(authenticated);
      setIsChecking(false);
    };

    // Pequeño delay para asegurar que el token esté disponible después del login
    setTimeout(checkAuth, 100);
  }, []);

  if (isChecking) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Verificando autenticación...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
